import { injectable } from '@patsnap/tahiti-core/shared/inversify';
import { SpecificationSectionManager, type GenerateQueueTask } from '../specification-section-manager';

@injectable()
export class SpecificationSectionManagerImpl implements SpecificationSectionManager {
    public generateQueue: GenerateQueueTask[] = [];

    addTask(...tasks: GenerateQueueTask[]) {
        this.generateQueue.push(...tasks);
        return this;
    }

    prependTask(...tasks: GenerateQueueTask[]) {
        this.generateQueue.unshift(...tasks);
        return this;
    }

    hasTask() {
        return this.generateQueue.length > 0;
    }

    nextTask() {
        return this.generateQueue.shift();
    }

    clearTasks() {
        this.generateQueue = [];
    }
}
